import React, { createContext, useContext, useEffect } from "react";
import { useAuth } from "./AuthContext";
import { useTabelaPreferenciaUI } from "../hooks/useTabelaPreferencia";

const PrecosContext = createContext();

export function PrecosProvider({ children }) {
  const { canViewPrices } = useAuth();
  // Bloco TBL.6 (2026-05-25): precos_solicitados (toggle do olho) passa
  // a persistir no backend via PreferenciasTabelasContext.ui. Cross-device:
  // usuario clica olho em desktop, ja entra com olho aberto em mobile.
  const { ui, setUI } = useTabelaPreferenciaUI();
  const precosSolicitados = Boolean(ui?.precos_solicitados);
  const precosVisiveis = Boolean(canViewPrices && precosSolicitados);

  // Quando usuario perde permissao (raro mas defensivo), zera o toggle
  // para nao mostrar olho aberto sem permissao.
  useEffect(() => {
    if (!canViewPrices && precosSolicitados) {
      setUI({ precos_solicitados: false });
    }
  }, [canViewPrices, precosSolicitados, setUI]);

  const togglePrecos = () => {
    if (!canViewPrices) return;
    setUI({ precos_solicitados: !precosSolicitados });
  };

  return (
    <PrecosContext.Provider value={{ precosVisiveis, togglePrecos, canViewPrices }}>
      {children}
    </PrecosContext.Provider>
  );
}

export const usePrecosVisiveis = () => useContext(PrecosContext);
